module.exports = __webpack_public_path__ + "static/media/calculate.21fcf989.mp3";